import React from "react";
import { getInsurerName } from "../../utils/insurer-name";
import {
	getInsurerCompanyNo,
	DISTRIBUTOR_STATEMENT,
} from "../../utils/insurer-legal";

/**
 * Underwriter / distributor disclosure — TIMB NDDP item 1 (Ansa-Support#30).
 *
 * Renders the underwriter's registered legal name, its company number where we hold one,
 * and the distributor statement. Shown wherever the customer is told who carries the risk:
 * the plan card, the package page and the payment summary. The insurer logo on its own is
 * explicitly not sufficient for this requirement, so this block always accompanies it.
 *
 * 12px ≈ 9pt, above the 8pt floor BNM's Guidelines on Product Transparency and Disclosure
 * (para 8.2.3) set for disclosure statements of this kind.
 */
const UnderwriterDisclosure = ({ insurerName, className = "" }) => {
	if (!insurerName) return null;

	const companyNo = getInsurerCompanyNo(insurerName);

	return (
		<div className={`pb-3 ${className}`.trim()}>
			<span style={{ fontSize: "12px", lineHeight: "14px" }}>
				{`Underwritten by ${getInsurerName(insurerName)}`}
				<br />
				{companyNo && (
					<>
						{`Company No.: ${companyNo}`}
						<br />
					</>
				)}
				{DISTRIBUTOR_STATEMENT}
			</span>
		</div>
	);
};

export default UnderwriterDisclosure;
